import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { AppSettings } from 'src/app/app.settings';
import { SentEmailFilterInterface, SentEmailInterface } from 'src/app/interfaces/campaigns/history/history.interface';

@Injectable({
  providedIn: 'root'
})
export class MarketingCampaignsHistoryService {

  constructor(
    private baseRestAngular: Restangular,
    private restAngular: Restangular
  ) {
    this.restAngular = this.getCustomRestAngular();
  }

  getCustomRestAngular() {
    return this.baseRestAngular.withConfig((RestangularConfigurer: any) => {
      RestangularConfigurer.setBaseUrl(AppSettings.getMarketingEndpoint());
    });
  }

  getAll(params: SentEmailFilterInterface): Promise<{ history: SentEmailInterface[], count: number }> {
    return this.restAngular.one('history').customGET('', params).toPromise();
  }

  getById(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }
}
